import { Link } from "react-router-dom";

const footerLinks = {
  "Sayfalar": [
    { label: "Anasayfa", path: "/" },
    { label: "Hakkımızda", path: "/hakkimizda" },
    { label: "Hizmetler", path: "/hizmetler" },
    { label: "Döviz Kurları", path: "/doviz-kurlari" },
    { label: "Hesaplama", path: "/hesaplama" },
    { label: "Galeri", path: "/galeri" },
  ],
  "Hizmetler": [
    { label: "Döviz Alım Satım", path: "/hizmetler/doviz-alim-satim" },
    { label: "Altın Alım Satım", path: "/hizmetler/altin-alim-satim" },
    { label: "Gümüş Alım Satım", path: "/hizmetler/gumus-alim-satim" },
    { label: "Efektif İşlemler", path: "/hizmetler/efektif-islemler" },
    { label: "Kur Danışmanlığı", path: "/hizmetler/kur-danismanligi" },
  ],
  "Yasal": [
    { label: "KVKK", path: "/kvkk" },
    { label: "Çerez Politikası", path: "/cerez-politikasi" },
  ],
};

const socialLinks = [
  { icon: "ri-instagram-line", href: "#", label: "Instagram" },
  { icon: "ri-twitter-x-line", href: "#", label: "X" },
  { icon: "ri-linkedin-line", href: "#", label: "LinkedIn" },
];

export default function Footer() {
  return (
    <footer className="bg-dark-100 border-t border-gold/10">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3">
              <img
                src="/images/logo.webp"
                alt="BEY Döviz"
                width={40}
                height={40}
                className="h-10 w-auto object-contain"
                loading="lazy"
              />
            </Link>
            <p className="mt-4 text-white/50 text-sm font-montserrat leading-relaxed max-w-xs">
              Döviz, altın ve gümüş alım-satım işlemlerinde güvenilir, hızlı ve şeffaf hizmet sunan profesyonel döviz bürosu.
            </p>

            {/* Contact Info */}
            <div className="mt-6 flex flex-col gap-3">
              <a href="https://wa.me/905056622000" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/60 hover:text-gold text-sm font-montserrat transition-smooth group">
                <i className="ri-whatsapp-line text-gold group-hover:scale-110 transition-smooth"></i>
                0505 662 20 00 (WhatsApp)
              </a>
              <a href="mailto:info@beydoviz.com" className="flex items-center gap-3 text-white/60 hover:text-gold text-sm font-montserrat transition-smooth group">
                <i className="ri-mail-line text-gold group-hover:scale-110 transition-smooth"></i>
                info@beydoviz.com
              </a>
              <div className="flex items-center gap-3 text-white/60 text-sm font-montserrat">
                <i className="ri-time-line text-gold"></i>
                Pzt–Cmt: 09:00 – 18:00
              </div>
              <div className="flex items-center gap-3 text-white/60 text-sm font-montserrat">
                <i className="ri-map-pin-line text-gold"></i>
                Kültür Mah. Talatpaşa Bulvarı 1/C, Alsancak, İzmir
              </div>
            </div>

            {/* Social Links */}
            <div className="mt-6 flex items-center gap-3">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-white/10 text-white/40 hover:text-gold hover:border-gold/30 hover:scale-110 transition-smooth"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-gold text-xs font-semibold uppercase tracking-widest font-montserrat mb-5">
                {title}
              </h4>
              <ul className="flex flex-col gap-3">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="group text-white/50 hover:text-white text-sm font-montserrat transition-smooth cursor-pointer flex items-center gap-0 hover:gap-2"
                    >
                      <i className="ri-arrow-right-s-line text-gold/0 group-hover:text-gold/70 text-xs transition-smooth"></i>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-dark-500">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs font-montserrat">
            &copy; {new Date().getFullYear()} BEY Döviz. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/kvkk" className="text-white/30 hover:text-white/60 text-xs font-montserrat transition-smooth cursor-pointer">
              KVKK
            </Link>
            <span className="text-white/20">|</span>
            <Link to="/cerez-politikasi" className="text-white/30 hover:text-white/60 text-xs font-montserrat transition-smooth cursor-pointer">
              Çerez Politikası
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
